export default function About() {
  return (
    <div className="bg-black min-h-screen text-white">

      {/* Hero */}
      <section className="max-w-4xl mx-auto px-4 pt-20 pb-12 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          We built BuildBright because finding a good contractor{" "}
          <span className="text-orange-500">shouldn't be this hard.</span>
        </h1>
        <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
          Alfred started BuildBright after watching homeowners get burned by
          unreliable contractors — and watching good contractors lose jobs
          because they had no marketing. BuildBright fixes both sides.
        </p>
      </section>

      {/* Stats Bar */}
      <section className="bg-zinc-900 border-y border-zinc-800 py-6">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-center">
          <div>
            <span className="text-orange-500 font-bold text-2xl">500+</span>
            <span className="text-zinc-300 ml-2">project requests reviewed</span>
          </div>
          <div className="text-zinc-600 hidden md:block">|</div>
          <div>
            <span className="text-orange-500 font-bold text-2xl">6</span>
            <span className="text-zinc-300 ml-2">service types</span>
          </div>
          <div className="text-zinc-600 hidden md:block">|</div>
          <div>
            <span className="text-zinc-300">Serving all of</span>
            <span className="text-orange-500 font-bold ml-2">the US</span>
          </div>
        </div>
      </section>

      {/* Why We're Different */}
      <section className="max-w-4xl mx-auto px-4 py-16">
        <h2 className="text-2xl font-bold text-white mb-4 text-center">
          Not Angi. Not HomeAdvisor. Something better.
        </h2>
        <p className="text-zinc-400 text-center mb-10 max-w-2xl mx-auto">
          Many home service platforms create a confusing experience for homeowners and contractors, often causing too many calls, repeated follow-ups, and
          spam, and profit off bidding wars. We don't do that.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: "✅", title: "No fake reviews", desc: "Every contractor is reviewed. No paid placements, no inflated ratings." },
            { icon: "🚫", title: "No bidding wars", desc: "Homeowners request project support through a clear intake process. No auction-style race to the bottom." },
            { icon: "📍", title: "Real local contractors", desc: "We only work with contractors who are licensed, insured, and know their local markets." },
            { icon: "💰", title: "Fair, transparent pricing", desc: "Contractors see claim-credit requirements up front. Homeowners get a clearer project intake experience before choosing next steps." },
          ].map(({ icon, title, desc }) => (
            <div key={title} className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
              <div className="text-2xl mb-2">{icon}</div>
              <h3 className="text-white font-semibold text-lg mb-1">{title}</h3>
              <p className="text-zinc-400 text-sm">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* For Homeowners */}
      <section className="bg-zinc-950 border-y border-zinc-800 py-16">
        <div className="max-w-4xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-xl font-bold text-orange-500 mb-3">For Homeowners</h2>
            <p className="text-zinc-300 mb-4">
              Stop scrolling through reviews you can't trust. Tell us what you
              need and where you are — we'll match you with a licensed local pro
              who's ready to give you a real quote.
            </p>
            <ul className="text-zinc-400 text-sm space-y-2">
              <li>✔ Free to use — no cost to homeowners</li>
              <li>✔ Matched in minutes, not days</li>
              <li>✔ Roofing, solar, HVAC, landscaping, and more</li>
            </ul>
          </div>
          <div>
            <h2 className="text-xl font-bold text-orange-500 mb-3">For Contractors</h2>
            <p className="text-zinc-300 mb-4">
              You do the work. BuildBright helps organize relevant project opportunities. BuildBright connects you with homeowners who are already looking for what you offer —
              no cold calls, no door knocking, no wasted time.
            </p>
            <ul className="text-zinc-400 text-sm space-y-2">
              <li>✔ Use claim credits only when unlocking project details</li>
              <li>✔ Choose your coverage area and service types</li>
              <li>✔ Real-time delivery by email and text</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-4xl mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl font-bold text-white mb-4">Ready to get started?</h2>
        <p className="text-zinc-400 mb-8">Whether you're a homeowner or a contractor, we built this for you.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/#/get-quotes"
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            Get a Free Quote
          </a>
          <a
            href="/#/contractors/pricing"
            className="border border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            Join as a Contractor
          </a>
        </div>
      </section>

    </div>
  );
}
